import PropTypes from 'prop-types'
import cx from 'classnames'
import { BrowserView, MobileView } from 'react-device-detect'
import { Form } from "react-bootstrap";

const Sidebar = ({ items, onItemClick, activeItem }) => {
  const handleOnChange = ({ target }) => {
    console.log(target.value);
    onItemClick(target.value);
  }

  return (
    <div className="card">
      <div className="card-header">Departments</div>
      <div className="card-body">
        <MobileView>
          <Form.Control
            bsPrefix={"form-select"}
            as="select"
            defaultValue={activeItem ? activeItem : ""}
            onChange={handleOnChange}
          >
            <option key="all" value={""}>
              All
            </option>
            {items.map((v, k) => (
              <option key={k} value={v.id}>
                {v.label}
              </option>
            ))}
          </Form.Control>
        </MobileView>
        <BrowserView>
          <div className="d-flex align-items-start">
            <div role="tablist" className="nav flex-column nav-pills">
              <a className={cx("nav-link", { active: activeItem === null})} onClick={() => onItemClick(null)}>All</a>
              {items.map((v, k) => (
                <a
                  key={k}
                  className={cx("nav-link", { active: v.id === activeItem })}
                  onClick={() => onItemClick(v.id)}
                >
                  {v.label}
                </a>
              ))}
            </div>
          </div>
        </BrowserView>
      </div>
    </div>
  );
}

Sidebar.propTypes = {
  items: PropTypes.array.isRequired,
  activeItem: PropTypes.string,
  onItemClick: PropTypes.func.isRequired
}

export default Sidebar
